const CheckIcon = () => (
  <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M1 5.2 4.2 8.4 11 1.6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Stepper({ stepperLength, stepperCurrentIndex }) {
  const total = stepperLength || 0;
  const current = stepperCurrentIndex || 0;
  const progress = total > 1 ? (current / (total - 1)) * 100 : 0;

  const stateOf = (index) => (index < current ? "done" : index === current ? "current" : "upcoming");

  return (
    <div className="pretest-stepper-wrap">
      {/* Desktop: numbered steps with connectors */}
      <div className="pretest-stepper" role="list">
        {[...Array(total)].map((_, index) => (
          <div className="pretest-stepper__node" key={index}>
            {index > 0 && <span className={`pretest-stepper__line ${index <= current ? "is-done" : ""}`} />}
            <span className={`pretest-stepper__dot is-${stateOf(index)}`} role="listitem">
              {index < current ? <CheckIcon /> : index + 1}
            </span>
          </div>
        ))}
      </div>

      {/* Mobile: compact progress bar + counter */}
      <div className="pretest-stepper-mobile" aria-hidden="false">
        <div className="pretest-stepper-mobile__track">
          <div className="pretest-stepper-mobile__fill" style={{ width: `${progress}%` }} />
        </div>
        <span className="pretest-stepper-mobile__count">
          {Math.min(current + 1, total)} / {total}
        </span>
      </div>
    </div>
  );
}
